export const APP_NAME = 'PMS'
export const PERSIST_STORE_NAME = 'whiteboard'
export const REDIRECT_URL_KEY = 'redirectUrl'
